import { cn } from '@/lib/cn';

// Backend (Laravel) returns statuses in UPPER_SNAKE_CASE — see TOURNAMENT_STATUS
// and EMatchStatus enums in @/types/enums. Original keys were camelCase from
// an earlier frontend convention; they never matched the live API.
// Match-level statuses (WAITING, COLLECTING, CONFLICT) are folded in here too
// so the same StatusBadge component serves both tournament and match contexts.
const STATUS_LABEL: Record<string, string> = {
  // Tournament-level
  OPENED: 'Soon',
  PENDING: 'Pending',
  REGISTRATION_OPENED: 'Open',
  REGISTRATION_CLOSED: 'Closed',
  CHECKIN: 'Check-in',
  STARTED: 'Live',
  IN_PROGRESS: 'Live',
  FINISHED: 'Complete',
  CLOSED: 'Closed',
  // Match-level
  WAITING: 'Soon',
  COLLECTING: 'In game',
  CONFLICT: 'Conflict',
};

const STATUS_TONE: Record<string, string> = {
  // Tournament
  OPENED: 'bg-bg-tertiary text-fg-muted',
  PENDING: 'bg-bg-tertiary text-fg-muted',
  REGISTRATION_OPENED: 'bg-brand/15 text-brand',
  REGISTRATION_CLOSED: 'bg-fg-muted/15 text-fg-muted',
  CHECKIN: 'bg-warning/15 text-warning',
  STARTED: 'bg-success/15 text-success',
  IN_PROGRESS: 'bg-success/15 text-success',
  FINISHED: 'bg-fg-muted/15 text-fg-muted',
  CLOSED: 'bg-fg-muted/15 text-fg-muted',
  // Match
  WAITING: 'bg-bg-tertiary text-fg-muted',
  COLLECTING: 'bg-success/15 text-success',
  CONFLICT: 'bg-danger/15 text-danger',
};

interface StatusBadgeProps {
  status: string;
  className?: string;
}

export function StatusBadge({ status, className }: StatusBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-medium uppercase tracking-wide',
        STATUS_TONE[status] ?? 'bg-bg-tertiary text-fg-muted',
        className,
      )}
    >
      {STATUS_LABEL[status] ?? status}
    </span>
  );
}
